import { ConstraintWaterSupplyBase } from './base/constraint-water-supply-base';

export class ConstraintWaterSupply extends ConstraintWaterSupplyBase { }